import React, { PropTypes } from 'react';
import Big from 'big.js';
import cx from 'classnames';

const onDeleteClick = onDelete => evt => {
  onDelete();
  evt.stopPropagation();
};

const deleteButtonClass = readOnly => {
  return cx('ui basic icon red button delete', {
    disabled: readOnly,
  });
};

const renderByDefaultLabel = byDefault => {
  if (byDefault === 'true') {
    return <a className="ui green label">Oui</a>;
  } else {
    return <a className="ui red label">Non</a>;
  }
};

const renderLineTypeOption = (lineType, lineTypeOptions) =>
  lineTypeOptions.find(t => t.value === lineType).text;

const AASTBillLine = ({
  key,
  data,
  readOnly,
  onClick,
  onDelete,
  isModel,
  lineTypeOptions,
  index,
}) => (
  <tr
    className="lineDetail"
    data-label={data.label}
    data-quantity={data.quantity}
    data-unit_price_ht={data.unit_price_ht}
    data-unit_price_ttc={data.unit_price_ttc}
    data-tva_rate={data.tva_rate}
    data-tva_amount={data.tva_amount}
    data-total_ht={data.total_ht}
    data-total_ttc={data.total_ttc}
    data-line_type={data.line_type}
    data-accounting_code={data.accounting_code}
    data-order={index}
    onClick={onClick}
  >
    <td>
      <a
        href="#"
        className={deleteButtonClass(readOnly)}
        onClick={onDeleteClick(onDelete)}
      >
        <i className="remove icon" />
      </a>
    </td>
    <td className="label">
      <strong>{data.label}</strong>
      <br />
      <span dangerouslySetInnerHTML={{ __html: data.description }} />
    </td>
    <td className="unit_price_ht">{Big(data.unit_price_ht).toFixed(4)}</td>
    <td className="quantity">{Big(data.quantity).toFixed(2)}</td>
    <td className="tva_rate">{data.tva_rate + ' %'}</td>
    <td className="tva_amount">{new Big(data.tva_amount).toFixed(2)}</td>
    <td className="total_ttc">{new Big(data.total_ttc).toFixed(2)}</td>
    <td className="line_type">
      {renderLineTypeOption(data.line_type, lineTypeOptions)}
    </td>
    {isModel && <td>{renderByDefaultLabel(data.by_default)}</td>}
  </tr>
);

AASTBillLine.propTypes = {
  data: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
};

export default AASTBillLine;



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/AASTBillLine.js